/**
 * index.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import { createRoot } from 'react-dom/client';
import '@fontsource/google-sans/400.css';
import '@fontsource/google-sans/500.css';
import '@fontsource/google-sans/700.css';
import './main.css';

import App from './main';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);
